export default {
  title: '客户关系管理',
  header: '客户关系管理',
  lead: {
    header: '联络',
    leadList: '名单',
    keywords: '关键字',
    create: {
      header: '新增联络',
      type: '种类',
      dateOfContact: '接触日期',
      name: '名称',
      phoneNumber: '电话号码',
      gender: '性别',
      identityCardNo: '身分证号码',
      status: '状态',
      remarks: '备注',
      activityLog: '活动记录',
      header: '新增联络',
      level: '层级',
      createTime: '新增时候',
      updateTime: '最后更新',
      confirmation: '确认要新增或编辑?',
      success: '新增或编辑成功',
      leadLevel: '层级',

    },
    convertToCustomer: '由联络转为客户',
    page: '页数',
    total: '总数',
    items: '项目',
    search: '搜寻',
    dateFrom: '由',
    dateTo: '至',
    clear: '清除过滤器'
  },
  edit: '编辑',
  customer: {
    header: '客户',
    customerList: '列表',
    success: '操作成功',
    doubleClick: '连按两次点选一个联络',
    importFromLead: '由连络汇入',
    customerName: '客户名称',
    search: '搜寻客户',
    currentAgent: '负责顾问',
    edit: '编辑',
    create: {
      header: '新增客户',

      customerType: '客户类别',
      customerCode: '客户编号',
      englishFirstname: 'English Surname',
      englishLastname: 'English Other Name',
      chineseLastname: '中文姓',
      chineseFirstname: '中文名字',
      englishCompanyName: 'English Company Name',
      chineseCompanyName: '中文公司名',
      identityCardNo: '身分证号码',
      brNo: '商业登记证号码',
      gender: '姓别',
      dateOfBirth: '出生日期',
      idType: '身分证类别',
      maritalStatus: '婚姻状况',
      contactType: '联络种类',
      defaultAddress: '预设地址',

      smoker: '吸烟者',
      education: '教育',
      occupation: '职业',
      nameOfEmployer: '雇主名称',
      lengthOfServices: '服务年资',

      telephoneMobile: '手机号码',
      telephoneHome: '屋企',
      telephoneOffice: '办公室',
      fax: '传真',
      email: '电邮',
      chineseResidentialAddress: '中文住址',
      englishResidentialAddress: 'Residential Address',
      chineseCorrespondenceAddress: '中文通报地址',
      englishCorrespondenceAddress: 'English',
      correspondenceAddressLeaveBlank: '如通讯地址跟住址一样则此项留空',
      companyCorrespondenceAddressLeaveBlank: '如通讯地址跟公司地址一样则此项留空',
      chineseCompanyAddress: '公司地址',
      englishCompanyAddress: 'Company Address',

      residentialAddress: '住址',
      correspondenceAddress: '通讯地址',
      companyAddress: '公司地址',

      personalHeader: '用户资料',
      userEmail: '用户电邮',
      language: '语言',
      marketingOptOut: '拒绝销售名单',

      generalHeader: '一般资料',
      contactHeader: '联络资料',
      customerHeader: '客户资料',

      confirmation: '确认新增客户?',
      header: '新增客户',

      success: '新增或编辑成功'
    },
    lifePolicyCount: '人寿保单数量',
    generalPolicyCount: '一般保险单数量',
    list: {
      lifePolicyCount: '{count} 人寿保单',
      generalPolicyCount: '{count} 一般保险单'
    },
  },
  calendar: {

    header: '行事历',
    indicator: {
      birthday: '生日',
      life: '人寿保单',
      gi: '一般保险单',
      serviceRequest: '服务申请',
      renewal: '续保'
    },
  },
}



// WEBPACK FOOTER //
// ./src/Crm/langs/zh_cn/index.js